import { FC, PropsWithChildren } from 'react';
import clsx from 'clsx';
import Style from './panelContainer.module.scss';
import { ReactComponent as Arrow } from 'assets/img/formBuilder/arrow_small_24.svg';
import { AppButton } from 'uikit/buttons';
import { SettingsPanelsNames } from '../../../settingsPanel/settingsPanel.context';
import { usePanelState } from '../../../settingsPanel/settingsPanelContextProvider';

export type PanelContainerProps = {
  variant?: 'flex' | 'block';
  header: string;
  expanded?: boolean;
  contentClassName?: string;
  panelName: SettingsPanelsNames;
};

export const PanelContainer: FC<PropsWithChildren<PanelContainerProps>> = ({
  children,
  expanded,
  header,
  variant = 'block',
  contentClassName,
  panelName,
}) => {
  const { isExpanded, toggleExpand } = usePanelState(panelName, expanded);

  return (
    <div className={Style.container} data-expanded={isExpanded && variant === 'flex'}>
      <div className={Style.header} onClick={toggleExpand}>
        {header}
        <AppButton
          variant={'icon-link'}
          colorSchema={'basic'}
          Icon={Arrow}
          iconClassName={clsx({ [Style.rotated180]: !isExpanded })}
        />
      </div>
      {isExpanded && <div className={clsx(Style.collapsibleContainer, contentClassName)}>{children}</div>}
    </div>
  );
};
